import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52faf386"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalIntroductoryContent = _resolveComponent("ModalIntroductoryContent")!
  const _component_VideoPlayButton = _resolveComponent("VideoPlayButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isIntroductoryContentModalOpen && _ctx.introductoryContent)
      ? (_openBlock(), _createBlock(_component_ModalIntroductoryContent, {
          key: 0,
          onClose: _ctx.closeModalIntroductoryContent,
          "introductory-content": _ctx.introductoryContent
        }, null, 8, ["onClose", "introductory-content"]))
      : _createCommentVNode("", true),
    (_ctx.introductoryContent?.youtube?.code)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fake-iframe",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openIntroductoryContent && _ctx.openIntroductoryContent(...args)))
        }, [
          _createElementVNode("img", {
            src: 
        `https://img.youtube.com/vi/${_ctx.introductoryContent?.youtube?.code}/hqdefault.jpg`
      ,
            alt: "thumbnail",
            onError: _cache[0] || (_cache[0] = 
        event =>
          (event.target.src = `https://img.youtube.com/vi/${_ctx.introductoryContent?.youtube?.code}/0.jpg`)
      )
          }, null, 40, _hoisted_1),
          (_ctx.introductoryContent)
            ? (_openBlock(), _createBlock(_component_VideoPlayButton, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}